import API from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IListResponse, ITeam } from '@umu/umu-types';

// 获取课程PK团队列表
export const getCoursePKTeams = async (id: string, course_id: string): Promise<IListResponse<ITeam>> => {
    return await fetchData(API.GET_COURSE_PK_TEAMS, {
        activity_id: id,
        course_id,
        page: 1,
        size: 100,
    });
};
